import React, { useState } from 'react';

import './coupon-code-item.css';
import { useTranslations } from 'next-intl';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { useGetCurrencies } from '@wwe-portal/web/providers/queries/offer';
import { cn } from '@wwe-portal/ui/lib/lib';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';

function CouponCodeItem({ data }) {
  const { isMobile } = useResponsive();

  const { data: activeCurrenciesData } = useGetCurrencies();
  const activeCurrencies = activeCurrenciesData?.data.data;
  /**
   * Use translation hook
   * @see https://react.i18next.com/
   */
  const t = useTranslations();

  const listCustomCurrencies = (data, customCurrencies) => {
    if (data.name.includes('Web Coins')) {
      const listOfCurrencies = customCurrencies?.filter(
        (el) => el.globalType !== 1
      );
      return listOfCurrencies?.map((el) => {
        return (
          <li key={el.id}>
            {Math.round(data.price * el.rate)} {el.name}
          </li>
        );
      });
    } else if (data.name.includes('Rubies')) {
      const listOfCurrencies = customCurrencies.filter(
        (el) => el.globalType !== 2
      );
      return listOfCurrencies.map((el) => {
        return (
          <li key={el.id}>
            {Math.round(data.price * el.rate)} {el.name}
          </li>
        );
      });
    }
    return customCurrencies.map((el) => {
      return (
        <li key={el.id}>
          {Math.round(data.price * el.rate)} {el.name}
        </li>
      );
    });
  };

  const [show, setShow] = useState(false);
  return (
    <div className="couponCodePopupExist__item relative">
      {show ? (
        <div className="couponCodePopupExist__infoBackground">
          <div className={`couponCodePopupExist__infoListBackground`}>
            <div className="couponCodePopupExist__infoListHeader">
              <p>{t('offer_contents')}</p>
              <IcoMoonIcon
                iconName="close"
                className="size-4 cursor-pointer p-[2px]"
                onClick={() => setShow(false)}
              />
            </div>
            <ul className="couponCodePopupExist__infoList hover-state__blur__list">
              {data.itemNames.map((el, index) => {
                return <li key={index}>{el}</li>;
              })}
              {listCustomCurrencies(data, activeCurrencies)}
              {data.name.includes('Web Coins') ||
              data.name.includes('Rubies') ? null : (
                <li> VIP {t('points')}</li>
              )}
            </ul>
          </div>
        </div>
      ) : (
        <div className="couponCodePopupExist__itemBackGround relative h-full">
          <div
            className={cn(`couponCodePopupExist__bgWrapper p-[15px]`, {
              'p-[5px]': isMobile,
            })}
            style={{
              backgroundImage: `url(${data.backgroundImg})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '500px',
            }}
          >
            <div className="couponCodePopupExist__img flex items-center justify-center">
              {data.itemImg
                ? data.itemImg.map((item, index) => {
                    return (
                      <img
                        src={data?.itemImg[0] ? item : null}
                        alt="bonus_item"
                        style={{
                          maxHeight: data.itemImg.length > 1 ? '50px' : '60px',
                        }}
                        key={index}
                      />
                    );
                  })
                : null}
            </div>
          </div>
          <div className="couponCodePopupExist__bottom flex items-center">
            <div
              className={`couponCodePopupExist__wrapperText text-center text-xs font-medium`}
            >
              {data.quantity > 1 ? (
                <span>
                  {data?.name ? `x${data.quantity} ${data.name}` : ''}
                </span>
              ) : (
                <span>{data?.name ? `${data.name}` : ''}</span>
              )}
            </div>
            <div className="shop-offer-card__actions__badge shop-offer-card__actions__badge__info text-text600 rounded text-xs">
              <IcoMoonIcon
                iconName="information-fill"
                className="size-4"
                onClick={() => setShow(true)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CouponCodeItem;
